// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2cCYB","fileBtn":"File_fileBtn__1epvW","closeBtn":"File_closeBtn__5iR1c","fileSelected":"File_fileSelected__3XnrM","disabled":"File_disabled__2-ihl"};